import React, { useState } from 'react'
import DateRangeCalendar from './DateRangeCalendar'

// Date-range segmented control (design spec: one bordered box, 5px radius,
// 1px dividers between segments, brass-filled selected segment).
// `className` lets a page override the outer wrapper's placement; the default
// keeps the full-width, right-aligned placement every existing page relies on.
function TimeframeHeader({showAll=false, frame, setFrame, setDateRange, dateRange, setLoadCaseAnalytics, setPaginateLimit = () => {}, className}) {
  const [showCustomCalendar, setShowCustomCalendar] = useState(false);

  const applyPreset = (key, startDate, endDate) => {
    setShowCustomCalendar(false);
    setPaginateLimit((prev) => ({...prev, skip: 0}));
    setFrame(key);
    setDateRange([{ startDate, endDate, key: 'selection' }]);
    setLoadCaseAnalytics(prev => !prev);
  };

  const options = [
    ...(showAll ? [{ key: 'all', label: 'All', onClick: () => applyPreset('all', null, null) }] : []),
    { key: 'today', label: 'Today', onClick: () => applyPreset('today', new Date(Date.now()), new Date(Date.now())) },
    { key: 'week', label: '7 days', onClick: () => applyPreset('week', new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), new Date(Date.now())) },
    { key: 'month', label: '30 days', onClick: () => applyPreset('month', new Date(Date.now() - 30 * 24 * 60 * 60 * 1000), new Date(Date.now())) },
    { key: 'custom', label: 'Custom', onClick: () => { setFrame('custom'); setShowCustomCalendar(prev => !prev); } },
  ];

  return (
    <div className={className || 'flex w-full flex-wrap lg:justify-end items-center lg:px-20'}>
      <div className='relative'>
        <div className='flex font-plexsans text-[12.5px] rounded-[5px] overflow-hidden bg-white' style={{ border: '1px solid rgba(20,33,61,.15)' }}>
          {options.map((opt, i) => {
            const isSelected = frame === opt.key;
            return (
              <div
                key={opt.key}
                onClick={opt.onClick}
                className={'cursor-pointer whitespace-nowrap transition-colors' + (isSelected ? '' : ' hover:bg-cream')}
                style={{
                  padding: '9px 16px',
                  fontWeight: isSelected ? 600 : 500,
                  background: isSelected ? '#8a6231' : undefined,
                  color: isSelected ? '#fffdf8' : 'rgba(20,33,61,.55)',
                  borderLeft: i === 0 ? 'none' : '1px solid rgba(20,33,61,.12)',
                }}
              >
                {opt.label}
              </div>
            );
          })}
        </div>
        {dateRange && showCustomCalendar &&
          <div className='z-40 bg-white absolute shadow-xl right-0 top-11 border rounded-lg overflow-hidden max-lg:right-auto max-lg:left-0 max-lg:max-w-[calc(100vw-32px)] max-lg:overflow-x-auto'>
            {/* phones: opens from the left edge of the buttons so it stays on screen */}
            <DateRangeCalendar setDateRange={setDateRange} dateRange={dateRange}/>
            <div className='shadow-md cursor-pointer m-2 mt-0 p-4 bg-tan hover:bg-tanDark text-ivory font-bold rounded flex justify-center items-center' onClick={() => { setShowCustomCalendar(false); setLoadCaseAnalytics(prev => !prev); }}>Load data for this date range</div>
          </div>
        }
      </div>
    </div>
  )
}

export default TimeframeHeader
